import {useState} from "react";
import {addMenuItem, uploadImage} from "../../Services/MenuItemService";
import {useFormValidation} from "../../Validation/UseFormValidation";
import {AddMenuItemScheme} from "../../Validation/FormSchemes/AddMenuItemScheme";
import {ErrorMessage} from "../../Components/ErrorMessage";
import {compressImage} from "../../Helpers/ImageCompressor";

type Props = {
  onSaved: () => void;
};

function AddMenuItemBody({onSaved}: Props) {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    picturePath: "",
  });
  
  const [imageFile, setImageFile] = useState<File | null>(null);

  const {errors, validateForm, resetErrors} = useFormValidation(AddMenuItemScheme);

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const characterCount = formData.description.length;

  const handleSave = async () => {
    try {
      const isValid = validateForm({
        ...formData,
        picturePath: imageFile ? "pending" : formData.picturePath,
      });

      if (!isValid) return;

      let picturePath = formData.picturePath;
      if (imageFile) {
        const compressedFile = await compressImage(imageFile);
        picturePath = await uploadImage(compressedFile);
      }

      await addMenuItem({
        name: formData.name,
        description: formData.description,
        madeOnDay: new Date().toISOString(),
        price: parseFloat(formData.price),
        picturePath,
      });

      resetErrors();
      onSaved();
    } catch (err) {
      console.error(err);
      alert("Opslaan mislukt");
    }
  };

  return (
    <form>
      <h2 className="header-1">Gerecht aanmaken</h2>

      <p className="popup-description">
        Dit gerecht word toegevoegd aan de opgeslagen gerechten. 
        Deze kan je later makkelijk kiezen bij het invullen van het weekmenu.
      </p>

      <div className="form-item">
        <h3 className="input-label">Naam</h3>
        <input
          id="menu-name"
          name="name"
          className="input-field"
          value={formData.name}
          onChange={handleChange}
        />
        <ErrorMessage error={errors.name}/>
      </div>

      <div className="form-item">
        <ul className="text-area-labels">
          <li>
            <h3 className="input-label">Beschrijving</h3>
          </li>
          <li className="character-count">
            <h3>{characterCount}/500</h3>
          </li>
        </ul>
        <textarea
          id="menu-description"
          name="description"
          className="text-area"
          value={formData.description}
          onChange={handleChange}
        />
        <ErrorMessage error={errors.description}/>
      </div>
      
      <div className="form-item">
        <h3 className="input-label">Prijs</h3>
        <input
          id="menu-price"
          name="price"
          className="input-field input-field--small"
          value={formData.price}
          onChange={handleChange}
        />
        <ErrorMessage error={errors.price}/>
      </div>

      <div className="form-item">
        <h3 className="input-label">Foto</h3>
        <input
          id="menu-image"
          type="file"
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files?.[0] ?? null)}
        />
        <ErrorMessage error={errors.picturePath}/>
      </div>

      <div className="align-button-right">
        <button type="button" onClick={handleSave} className="button">
          Opslaan
        </button>
      </div>
    </form>
  );
}

export default AddMenuItemBody;
